export default __webpack_public_path__ + "static/media/message-icon-new.460d23e5.png";